import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[siPreventDoubleClick]'
})
export class PreventDoubleClickDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('click', ['$event'])
  async clickEvent(event: any) {
    if (event.srcElement.parentElement.nodeName === 'BUTTON') {
      event.srcElement.parentElement.classList.toggle('disabled');
      setTimeout(function() {
        if (event.srcElement) {
          event.srcElement.parentElement.classList.toggle('disabled');
        }
      }, 1000);

      return;
    }

    if (event.srcElement.nodeName === 'BUTTON') {
      event.srcElement.classList.toggle('disabled');
      setTimeout(function() {
        if (event.srcElement) {
          event.srcElement.classList.toggle('disabled');
        }
      }, 1000);

      return;
    }

    if (this.el && this.el.nativeElement) {
      this.el.nativeElement.classList.toggle('disabled');
      setTimeout(() => {
        if (this.el && this.el.nativeElement) {
          this.el.nativeElement.classList.toggle('disabled');
        }
      }, 1000);
    }
  }
}
